import Urls from '../../utils/urlStrings'
import service from '../../utils/service'
import {
  getSessionId
} from '../../utils/helper'
import { MICROSERVICES } from '../../utils/constants'
import axios from 'axios'

export class UserService {


  async loginUser(values) {
    try {
      const response = await axios.post(Urls.getApiUrl(`application/login`, MICROSERVICES.HECOSDPMANAGER), {
        'username': values?.emailId,
        'password': values?.password
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async logoutUser() {
    try {
      const response = await service.delete(Urls.getApiUrl(`application/session/${getSessionId()}`, MICROSERVICES.HECOSDPMANAGER),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const userService = new UserService()
